<template>
  <v-row :class="styleClass" class="ma-0 base-toggle-container">
    <v-col :lg="minWidth ? 'auto' : ''" class="pr-2 pa-0">
      <v-btn
        elevation="0"
        value="Yes"
        rounded
        :data-uiid="getYesDataUiid"
        :aria-label="toggleButtonText?.yes ?? 'Yes'"
        :color="activeButton === 'Yes' ? '#7c869a' : 'white'"
        :block="!minWidth ? true : false"
        :min-width="minWidth"
        :max-width="maxWidth"
        :class="
          activeButton === 'Yes'
            ? 'white--text font-weight-bold'
            : 'primary--text btn-toggle-border font-weight-regular'
        "
        class="font-20 text-none"
        :height="height"
        @click="handleYes()"
      >
        {{ toggleButtonText?.yes ?? "Yes" }}
      </v-btn>
    </v-col>
    <v-col :lg="minWidth ? 'auto' : ''" class="pl-2 pa-0">
      <v-btn
        value="No"
        rounded
        :data-uiid="getNoDataUiid"
        :aria-label="toggleButtonText?.no ?? 'No'"
        :block="!minWidth ? true : false"
        :min-width="minWidth"
        :color="activeButton === 'No' ? '#7c869a' : 'white'"
        :class="
          activeButton === 'No'
            ? 'white--text font-weight-bold'
            : 'primary--text btn-toggle-border font-weight-regular'
        "
        class="font-20 text-none"
        :height="height"
        elevation="0"
        @click="handleNo()"
      >
        {{ toggleButtonText?.no ?? "No" }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: Boolean,
    height: String,
    toggleButtonText: Object,
    styleClass: {
      type: String,
      required: false,
    },
    minWidth: [String, Number],
    maxWidth: [String, Number],
  },
  computed: {
    activeButton: {
      get() {
        return this.value ? "Yes" : "No";
      },
      set(newVal) {
        return newVal;
      },
    },
    getYesDataUiid() {
      return this.toggleButtonText?.yesDataUiid ?? "Yes";
    },
    getNoDataUiid() {
      return this.toggleButtonText?.noDataUiid ?? "No";
    },
  },
  methods: {
    handleYes() {
      this.activeButton = "Yes";
      this.$emit("input", true);
      this.$emit("change", true);
    },
    handleNo() {
      this.activeButton = "No";
      this.$emit("input", false);
      this.$emit("change", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-toggle-border {
  border: solid 1px #7c869a !important;
}
</style>
